import * as React from 'react';

import styles from './MenuButton.css';

enum GalleryContent {
  photo = 'фото',
  video = 'Видео',
}

enum GalleryContentIcons {
  photo = 'icon-photo',
  video = 'icon-video',
}

export interface IControlsProps {
  type: keyof typeof GalleryContent;
  id: number;
  elementsCount: number;
  onButtonClick(id: number): void;
}

export const MenuButton = (props: IControlsProps) => {
  const { elementsCount, id, onButtonClick, type } = props;

  return (
    <div
      className={styles['menu_button']}
      onClick={() => {
        onButtonClick(id);
      }}
    >
      <div className={styles[GalleryContentIcons[type]]} />
      <h2 className={styles['title']}>{getTitle(type, elementsCount)}</h2>
    </div>
  );
};

function getTitle(type: keyof typeof GalleryContent, count: number) {
  return type === 'photo' ? `${count} ${GalleryContent[type]}` : GalleryContent[type];
}
